export default __webpack_public_path__ + "static/media/amasa.016401a1.png";